import {EEventSource, IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';
import {ENewsletterSubscriptionSection} from 'coreClasses/analytics/providers/gtm/IGoogleTagManager';

/**
 * Represents NewsletterSubcriptionEvent
 */
export default class NewsletterSubcriptionEvent implements IAnalyticsEvent {
	public event: string;
	public user_info: {newsletter_subscription: boolean};
	public nl_section?: string;

	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		const newsletterSubscription = data.isLoggedIn || false;

		this.event = EAnalyticsEventType.NEWSLETTER_SUBSCRIPTION;
		this.user_info = {newsletter_subscription: newsletterSubscription};
		this.nl_section = data?.eventSource && ENewsletterSubscriptionSection[EEventSource[data.eventSource]];
	}
}

